import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import axios from "axios";
import { set_page_refresh } from "../../redux/action";
import countriesData from "../../json/countries.json";
import courierMethodsData from "../../json/courierMethods.json";
import { APIgetStores } from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";


const AddCourier = () => {
  const dispatch = useDispatch();
 
  const MySwal = withReactContent(Swal);
  const [availableCourierMethods, setAvailableCourierMethods] = useState([]); // New state for available payment methods
  const [validationErrors, setValidationErrors] = useState({});
  const data = useSelector((state) => state.courier_edit);
  const closeRef = useRef(null);
  const [showTcsFields, setShowTcsFields] = useState(false);
  const [dataStore, setDataStore] = useState([]);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const storeOptions = [
    ...dataStore.map(store => ({
      value: store.value,
      label: store.label
    }))
  ];
  
  const [couriers, setCouriers] = useState({
    _id: "",
    country: "",
    stores: [],
    courierMethods: [], // List of selected payment methods
    courierDetails: [], // List of payment details per method
     
      clientID: "",
      clientSecret: "",
      portalCode: "",
      authToken: "",
      accessToken: "",

      urlAuth:"",
      username:"",
      password:"",
      baseUrl:""
  });

  const countriesOptions = [
    { value: "select_country", label: "Select Country", name: "Select Country" },
    ...countriesData.map(country => ({
        value: country.name,
        label: t?.[l]?.[country.name] || country.name
    }))
  ];

  useEffect(() => {
    if (data && Object.keys(data).length) {
      setCouriers({
        _id: data._id,
        country: data.country,
        stores: data.stores || [],
        courierMethods: data.courierMethods || [],
        courierDetails: data.courierDetails || [],
      
        clientID: data.courierDetails?.find(detail => detail.courierType === "tcs")?.clientID || "",
        clientSecret: data.courierDetails?.find(detail => detail.courierType === "tcs")?.clientSecret || "",
        portalCode: data.courierDetails?.find(detail => detail.courierType === "tcs")?.portalCode || "",
        authToken: data.courierDetails?.find(detail => detail.courierType === "tcs")?.authToken || "",
        accessToken: data.courierDetails?.find(detail => detail.courierType === "tcs")?.accessToken || "",
        urlAuth: data.courierDetails?.find(detail => detail.courierType === "tcs")?.urlAuth || "",
        username: data.courierDetails?.find(detail => detail.courierType === "tcs")?.username || "",
        password: data.courierDetails?.find(detail => detail.courierType === "tcs")?.password || "",
        baseUrl: data.courierDetails?.find(detail => detail.courierType === "tcs")?.baseUrl || "",
      });
      if(data.courierDetails?.find(detail => detail.courierType === "tcs"))
        setShowTcsFields(true);
      
      setAvailableCourierMethods(courierMethodsData[data.country] || []); // Set payment methods based on the country
    } else {
      resetForm();
    }
  }, [data]);

  // useEffect(() => {
  //   const handleHidden = () => {
  //     // Reset the form state when the modal is hidden
  //     resetForm();
  //   };

  //   const modalElement = document.getElementById('add-brand');
  //   modalElement?.addEventListener('hidden.bs.modal', handleHidden);

  //   return () => {
  //     modalElement?.removeEventListener('hidden.bs.modal', handleHidden);
  //   };
  // }, []);

  const resetForm = () => {
    setCouriers({
      _id: "",
      country: "",
      stores: [],
      courierMethods: [],
      courierDetails: [],

      clientID: "",
      clientSecret: "",
      portalCode: "",
      authToken: "",
      accessToken: "",
      urlAuth:"",
      username:"",
      password:"",
      baseUrl:""

    });
    setShowTcsFields(false)
    setAvailableCourierMethods([]); // Reset available payment methods
  };

  useEffect(() => {
    getStoreApi();
  }, []);

  const getStoreApi = async () => {
    const res = await APIgetStores({});
    if (res?.response?.stores) {
      const storeData = res.response.stores.reverse();
      console.log("storeData", storeData);
      const storeOptions = storeData.map((store) => ({
        label: store.title,// "(" + store.storeNumber + ")", // storeNumber
        value: store._id,
        storeCode: store.storeNumber, // Store code
      }));
      setDataStore(storeOptions);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      setCouriers((prevState) => ({
        ...prevState,
        country: value, // Update country
        courierMethods: [], // Reset payment methods
        courierDetails: [],

        clientID: "",
        clientSecret: "",
        portalCode: "",
        authToken: "",
        accessToken: "",
        urlAuth:"",
        username:"",
        password:"",
        baseUrl:""

      }));
      setAvailableCourierMethods(courierMethodsData[value] || []); // Set payment methods based on the selected country
    } else if (name === "storeId") {
      // eslint-disable-next-line no-debugger
      debugger;
      const selectedStores = value.map((id) => {
        const store = dataStore.find((s) => s.value == id);
        return store ? { storeId: id, storeCode: store.storeCode, storeName: store.label } : null;
      }).filter(Boolean); // Filter out any null values
    
      console.log("selectedStores", selectedStores);
    
      setCouriers((prevState) => ({
        ...prevState,
        stores: selectedStores,
      }));
    }
    else {
      setCouriers((prevState) => ({
        ...prevState,
        [name]: value,
      }));
       // Generate token if all required fields are filled
//     if (["clientID", "clientSecret", "urlAuth"].includes(name)) {
//       setCouriers((prevState) => {
//         const { clientID, clientSecret, urlAuth } = {
//           ...prevState,
//           [name]: value,
//         };

//         // if (clientID && clientSecret && urlAuth) {
//         //   return {
//         //     ...prevState,
//         //     authToken: "",//generateToken(clientID, clientSecret, urlAuth),//"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiZWE0ZmU1NzktMDQyZC00MDk5LWJkMTgtOTBmZGU5MTIyYWJmIiwibmJmIjoxNzM0MDA1NDY5LCJleHAiOjE4MjA0MDU0NjksImlhdCI6MTczNDAwNTQ2OX0.SEVZLSvp2t3DIk6EXC51iqtPErYFgcMw3Ea0Iqoph6M",//generateToken(clientID, clientSecret, urlAuth),
//         //   };
//         // }
// //jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYrMQJI8is5c3prMEsXmUUQA=
//         return prevState;
//       });
//     }
    }
  };

  // const generateToken = async (clientID, clientSecret, urlAuth) => {
  //   try {
  //     const response = await fetch(`${urlAuth}?ClientID=${encodeURIComponent(clientID)}&ClientSecret=${encodeURIComponent(clientSecret)}`, {
  //       method: "GET",
  //       headers: {
  //         accept: "text/plain",
  //       },
  //     });
  //     console.log("response token",response);//"accessToken"
  
  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch token: ${response.statusText}`);
  //     }
  
  //     const token = await response.text();
  //     return token;
  //   } catch (error) {
  //     console.error("Error generating token:", error);
  //     return ""; // Return empty string or handle error appropriately
  //   }
  // };
  
  const handleCheckboxChange = (method, isChecked) => {
    setCouriers((prevState) => {
      const updatedMethods = isChecked
        ? [...prevState.courierMethods, method] // Add method
        : prevState.courierMethods.filter((m) => m !== method); // Remove method

        couriers.courierDetails = couriers.courierDetails?.filter(
          detail => detail.courierType !== method
        );

      return {
        ...prevState,
        courierMethods: updatedMethods,
      };
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!couriers.country || couriers.country === "select_country") {
      errors.country = "Country is required.";
    }

    if (couriers.stores.length === 0) {
      errors.stores = "At least one store must be selected.";
    }

    if (couriers.courierMethods.length === 0) {
      errors.courierMethods = "At least one payment method must be selected.";
    }

    if (showTcsFields) {
      const bank = couriers.courierDetails.find((detail) => detail.courierType === "tcs");
      if (!bank?.clientID) {
        errors.clientID = "Client ID is required.";
      }
      if (!bank?.clientSecret) {
        errors.clientSecret = "Client Secret is required.";
      }

      if (!bank?.accessToken) {
        errors.accessToken = "Access Token is required.";
      }

      //
      if (!bank?.portalCode) {
        errors.portalCode = "Portal Code is required.";
      }
      if (!bank?.authToken) {
        errors.authToken = "Auth Token is required.";
      }
      
      if (!bank?.urlAuth) {
        errors.urlAuth = "url is required.";
      }
      if (!bank?.username) {
        errors.username = "Username is required.";
      }
      if (!bank?.password) {
        errors.password = "Password is required.";
      }
      if (!bank?.accessToken) {
        errors.accessToken = "Access Token is required.";
      }
      if (!bank?.baseUrl) {
        errors.baseUrl = "BaseUrl is required.";
      }
    }

    setValidationErrors(errors);
    console.log("Object.keys(errors).length",Object.keys(errors).length);
    return Object.keys(errors).length === 0;
  };

  const submit = async (event) => {
    event.preventDefault();
   // const form = event.currentTarget;
   console.log("before validation")
   {
      try {
        console.log("after if")
        //if (form?.checkValidity()) 

          if(couriers.courierMethods.includes("tcs"))
          {
            const { clientID, clientSecret, portalCode, authToken, urlAuth,
              username,
              password,
              accessToken,
              baseUrl } = couriers;
            couriers.courierDetails = couriers.courierDetails?.filter(
              detail => detail.courierType !== "tcs"
            );
            couriers.courierDetails?.push({
              courierType: "tcs",
              clientID,
              clientSecret,
              portalCode,
              authToken,
              accessToken,
              urlAuth,
              username,
              password,
              baseUrl
            });
          }
      

          if (validateForm()) 
          {
            delete couriers.clientID;
            delete couriers.clientSecret;
            delete couriers.portalCode;
            delete couriers.authToken;
            delete couriers.accessToken;
            delete couriers.urlAuth;
            delete couriers.username;
            delete couriers.password;
            delete couriers.baseUrl;
           
          try {
            await axios.post("addorupdatecourierconfig/", couriers);
            MySwal.fire({
              position: "top-end",
              icon: "success",
              title: "Created Successfully!",
              showConfirmButton: false,
              timer: 3000,
              })
          }
          catch(error)
          {
            console.error("Error submitting payment gateway:", error);
            MySwal.fire({
              position: "top-end",
              icon: "error",
              title: error.response.data.message,
              showConfirmButton: false,
              timer: 3000,
            });  
          }
            resetForm();
            closeRef.current?.click();
            dispatch(set_page_refresh("courierConfigs"));
          }
        
      } catch (error) {
        console.error("Error submitting payment gateway:", error);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }

  };

  return (
    <div className="modal fade" id="add-brand">
      <div className="modal-dialog modal-dialog-centered custom-modal-two modal-xl">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <h4>
                  {Object.keys(data || {}).length
                    ? t?.[l]?.["edit_courier"] || "Edit Courier"
                    : t?.[l]?.["add_courier"] || "Add Courier"}
                </h4>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body new-employee-field">
                <form onSubmit={submit}>
                  {/* Country Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["select_a_country_to_populate_its_payment_gateway_options"] || "Select a country to populate its payment gateway options"} <span>*</span>
                    </label>
                    <Select
                      className="select"
                      options={countriesOptions}
                      name="country"
                      value={countriesOptions.find(option => option.value === couriers.country) || countriesOptions[0]} // Default to the first country option if no match
                      onChange={(selectedOption) => {
                        handleInputChange({ target: { name: "country", value: selectedOption.value } });
                      }}
                    />
                    {validationErrors.country && <p className="text-danger">{validationErrors.country}</p>}
                  </div>
    
              
                {availableCourierMethods && availableCourierMethods.includes("tcs") &&(
                  <>
                  <div key="tcs" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={showTcsFields && couriers.courierMethods.includes("tcs")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowTcsFields(isChecked); // Update showTcsFields state
                        handleCheckboxChange("tcs", isChecked); // Update courierMethods
                      }}
                    />
                    <label htmlFor="checkbox-banktransfer" className="form-check-label">
                    {t?.[l]?.["tcs"] || "TCS" }
                    </label>
                  </div>
                  <hr />       
                    {showTcsFields && couriers.courierMethods.includes("tcs") && (
                      <>
                    <div className="d-flex flex-wrap">
                    <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["auth_url"] || "Auth URL" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="urlAuth"
                          value={couriers.urlAuth}
                          onChange={handleInputChange}
                          maxLength={300}
                          
                        />
                          {validationErrors.urlAuth && <p className="text-danger">{validationErrors.urlAuth}</p>}
         
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">  {t?.[l]?.["clientID"] || "Client ID" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="clientID"
                          value={couriers.clientID}
                          maxLength={200}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.clientID && <p className="text-danger">{validationErrors.clientID}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label"> {t?.[l]?.["clientSecret"] || "Client Secret" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="clientSecret"
                          value={couriers.clientSecret}
                          maxLength={200}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.clientSecret && <p className="text-danger">{validationErrors.clientSecret}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["auth_token"] || "Auth Token" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="authToken"
                          value={couriers.authToken}
                          onChange={handleInputChange}
                          maxLength={1000}
                        />
                          {validationErrors.authToken && <p className="text-danger">{validationErrors.authToken}</p>}
         
                      </div>

                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["portalCode"] || "Portal Code" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="portalCode"
                          value={couriers.portalCode}
                          maxLength={300}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.portalCode && <p className="text-danger">{validationErrors.portalCode}</p>}
           
                      </div>

                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["username"] || "User name" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="username"
                          value={couriers.username}
                          onChange={handleInputChange}
                          maxLength={300}
                          
                        />
                          {validationErrors.username && <p className="text-danger">{validationErrors.username}</p>}
         
                      </div>
                      
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["password"] || "Password" }<span>*</span></label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          value={couriers.password}
                          onChange={handleInputChange}
                          maxLength={300}
                          
                        />
                          {validationErrors.password && <p className="text-danger">{validationErrors.password}</p>}
         
                      </div>
                     
                      <div className="mb-3 me-3">
                        <label className="form-label">  {t?.[l]?.["acess_token"] || "Access Token" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="accessToken"
                          value={couriers.accessToken}
                          maxLength={1000}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.accessToken && <p className="text-danger">{validationErrors.accessToken}</p>}
           
                      </div>

                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["base_url"] || "Base Url" }<span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="baseUrl"
                          value={couriers.baseUrl}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                          {validationErrors.baseUrl && <p className="text-danger">{validationErrors.baseUrl}</p>}
         
                      </div>
                     
                    </div>
                    <hr />
                     </>
                  )} 
                 
                  </>
                )}
             
                  {/* Store Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["store"] || "Store"} <span>*</span>
                    </label>

                    <Select
                      className="select"
                      options={storeOptions}
                      name="storeId"
                      isMulti
                      placeholder="Select Store" // or any dynamic placeholder like {chooseStore}
                      value={couriers.stores.map(store => ({
                        value: store.storeId,
                        label: store.storeName,
                      }))}
                      onChange={(e) => handleInputChange({ target: { name: 'storeId', value: e.map(store => store.value) } })}
                    
                    />
                       {validationErrors.stores && <p className="text-danger">{validationErrors.stores}</p>}
                     
                  </div>
                  <div className="modal-footer-btn">
                     <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal" ref={closeRef}>{t?.[l]?.["cancel"] || "Cancel"}</button>
                     <button type="submit" className="btn btn-submit">{t?.[l]?.["save"] || "Save"}</button>
                   </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCourier;